import React from 'react'
import { useArtboard } from '@sketch-hq/sketch-prototype-player'
import * as Styles from './PrototypeName.styles'
import { useInitialPrototypeArtboardId } from 'modules/prototype/PrototypeViewOld/hooks'

export function PrototypeName() {
  const initialArtboardId = useInitialPrototypeArtboardId()
  const prototypeName = useArtboard(initialArtboardId)?.name

  return (
    <Styles.Container>
      <Styles.Icon />
      {prototypeName && <Styles.Label>{prototypeName}</Styles.Label>}
    </Styles.Container>
  )
}
